import Helmet from 'react-helmet';
import I18n from '../../config/i18n';
import metaLogo from './assets/casapilot_logo.png';

interface MetaProps {
  title?: string;
  description?: string;
  logo?: string;
  canonicalURL?: string;
}

export default function Meta({ title, logo, description, canonicalURL }: MetaProps): JSX.Element {
  return (
    <Helmet>
      <title>{I18n.t('meta.title', { title })}</title>
      <meta property="og:image" content={logo || metaLogo} />
      <meta property="og:title" content={title} />
      {description ? <meta property="og:description" content={description} /> : null}
      {description ? <meta name="description" content={description} /> : null}
      {canonicalURL ? <link rel="canonical" href={canonicalURL} /> : null}
    </Helmet>
  );
}

const defaultProps: Pick<MetaProps, 'title' | 'logo' | 'description' | 'canonicalURL'> = {
  title: 'selected homes',
  logo: undefined,
  description: undefined,
  canonicalURL: undefined,
};

Meta.defaultProps = defaultProps;
